export default __webpack_public_path__ + "static/media/Reader's Belt of the Burning Disc.8a81e68d.jpg";